import styled from "@emotion/styled";
export const FormLabelContentAfter = styled("span")`
    margin-left: 4px;
    display: flex;
`;
//# sourceMappingURL=FormLabelContentAfter.js.map